/**
 * FIX-257: company resale % (company_settings.harvest_recommendations.resale_price_pct)
 * as a fraction 0..1. 0 means 0% (resale price €0); only a missing or unreadable
 * value uses the fallback. Values above 1 are percentages (50 → 0.5).
 */
export const MISSING_RESALE_PCT_FALLBACK = 0.5;

export function normalizeResalePct(raw: unknown, fallback = MISSING_RESALE_PCT_FALLBACK): number {
  if (raw == null || raw === "") return fallback;
  const n = Number(raw);
  if (!Number.isFinite(n)) return fallback;
  return n > 1 ? n / 100 : n;
}

/** Resale price = new/original price × resale fraction. */
export function resaleValue(originalTotal: number, pctFraction: number): number {
  return (Number(originalTotal) || 0) * pctFraction;
}
